import React, { useEffect, useState } from 'react';
import { useAuth } from '../../commons/Auth';
import { useAlert } from 'react-alert';
import { useTranslation } from 'react-i18next';
import { useLoading } from '../../commons/Loading';
import { Link, Route, Switch, Redirect, withRouter } from 'react-router-dom';
import BurgerMenu from '../../commons/BurgerMenu';
import Header from '../../commons/Header';
import variables from '../../variables';
import { ReactComponent as IconProfile } from '../../images/icn_profilo.svg';
import { Card, CardBody, Nav, NavItem, NavLink } from 'reactstrap';
import classNames from 'classnames';
import Archive from './Archive';
import axios from 'axios';

function AdminInfos({ history, location, match = {} }) {
  const [{ newToken, newIsAdmin } = {}] = useAuth();
  const alert = useAlert();
  const [t] = useTranslation();
  const { showLoading, hideLoading } = useLoading();

  const { pathname = '', state = {} } = location;
  const tab = pathname.split('/').pop();

  if (!newIsAdmin)
    return (
      <Redirect
        push={false}
        to={{
          pathname: '/my-profile',
          state: { from: location },
        }}
      />
    );

  if (pathname === match.url) {
    return <Redirect to={`${match.url}/documents`} />;
  }

  return (
    <div className="App">
      <BurgerMenu />

      <div className="corpo">
        <section>
          <Header
            title={t('PAGES:ARCHIVE')}
            icon={<IconProfile fill={variables.white} />}
          />

          <div className="m-tb-20">
            <Nav tabs>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/documents`}
                  className={classNames({ active: tab === 'documents' })}
                >
                  {t('TABS:MY_DOCUMENTS')}
                </NavLink>
              </NavItem>
            </Nav>

            <Switch>
              <Route
                path={`${match.url}/documents`}
                component={(props) => (
                  <Card>
                    <CardBody>
                      <Archive></Archive>
                    </CardBody>
                  </Card>
                )}
              />
            </Switch>
          </div>
        </section>
      </div>
    </div>
  );
}

export default withRouter(AdminInfos);
